import { Grid } from '@material-ui/core';
import { inject, observer } from 'mobx-react';
import { withSnackbar } from 'notistack';
import React from 'react';
import DataView from '../../components/DataView';
import ContainerDataView from './ContainerDataView';

const ImportadorView = ({ values, isPhone }) => {
  return (
    <>
      <ContainerDataView title="Datos del Importador">
        <Grid container item xs={12} md={6} spacing={isPhone ? 1 : 0}>
          <Grid item xs={12}>
            <DataView
              label="Importador"
              value={values.nombreImportador}
              isPhone={isPhone}
            />
          </Grid>
          <Grid item xs={12}>
            <DataView
              label="Correo"
              value={values.emailImportador}
              isPhone={isPhone}
            />
          </Grid>
          <Grid item xs={12}>
            <DataView
              label="Dirección"
              value={values.direccionImportador}
              isPhone={isPhone}
            />
          </Grid>
          <Grid item xs={12}>
            <DataView
              label="Ciudad"
              value={values.ciudadImportador}
              isPhone={isPhone}
            />
          </Grid>
          <Grid item xs={12}>
            <DataView
              label="País"
              value={values.paisImportador}
              isPhone={isPhone}
            />
          </Grid>
          <Grid item xs={12}>
            <DataView
              label="Código Postal"
              value={values.codigoPostalImportador}
              isPhone={isPhone}
            />
          </Grid>
        </Grid>
      </ContainerDataView>
    </>
  );
};

export default inject('datos')(observer(withSnackbar(ImportadorView)));
